import SectionHead from "./SectionHead";
import { originTimeline } from "@/mocks/content";

export default function Origin() {
  return (
    <section id="origin" className="bg-[#fff4e6] py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="03 · 怎么来的"
          title="这个梗是怎样一步步火起来的"
          desc="流行语很少凭空诞生，53吃瓜也经历了从评论习惯到圈内默契、再到日常表达的演进过程。"
        />

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_1.15fr] lg:items-start">
          {/* 左侧插图 */}
          <div className="lg:sticky lg:top-24">
            <div className="relative overflow-hidden rounded-[2rem] shadow-soft">
              <img
                src="https://readdy.ai/api/search-image?query=vertical%20flat%20vector%20illustration%20of%20a%20timeline%20path%20with%20growing%20chat%20bubbles%20and%20bigger%20watermelon%20slices%20along%20the%20way%2C%20representing%20how%20an%20internet%20meme%20spreads%20and%20evolves%2C%20warm%20cream%20background%2C%20coral%20red%20and%20mint%20green%20and%20orange%20palette%2C%20clean%20minimal%20modern%20illustration&width=760&height=860&seq=origin-timeline-53-03&orientation=portrait"
                alt="网络流行语传播演变的时间轴插画"
                title="53吃瓜梗的起源与传播"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="mt-5 rounded-2xl bg-white p-5 ring-1 ring-orange-100">
              <p className="text-sm leading-relaxed text-stone-500">
                💡 小提醒：流行语是流动的，不同地区、不同社群的“版本”会有差异。本站整理的是目前最常见的使用逻辑，
                供你快速入门，具体含义请以你所在圈子为准。
              </p>
            </div>
          </div>

          {/* 时间线 */}
          <ol className="relative space-y-6 before:absolute before:left-5 before:top-3 before:bottom-3 before:w-0.5 before:bg-gradient-to-b before:from-rose-300 before:to-emerald-300">
            {originTimeline.map((t, i) => (
              <li key={t.title} className="relative pl-16">
                <span className="absolute left-0 top-1 grid h-10 w-10 place-items-center rounded-full bg-white font-heading text-sm text-rose-500 ring-2 ring-rose-300">
                  {i + 1}
                </span>
                <div className="rounded-3xl bg-white p-6 ring-1 ring-orange-100 transition-transform hover:-translate-y-0.5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-rose-100 px-3 py-1 text-xs font-medium text-rose-600">
                      {t.tag}
                    </span>
                    <span className="text-xs font-medium text-stone-400">{t.time}</span>
                  </div>
                  <h3 className="mt-3 text-lg font-bold text-stone-800">{t.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-stone-500">{t.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}